import { FC, useCallback } from "react";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip,
} from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { useAppDispatch } from "@/store/hooks";
import { filterOutResourceGridResourcesThunk } from "@/store/live-usage-mgmt/thunks/filterOutResourceGridResourcesThunk";

interface LiveUsageResourceGridFilterOutActionProps {
  masterGridId: string;
  onClose?(): void;
}

interface LiveUsageResourceGridToolbarFilterOutActionProps
  extends LiveUsageResourceGridFilterOutActionProps {
  disabled: boolean;
  tooltipTitle: string;
  inRowAction?: false;
}

interface LiveUsageResourceGridRowFilterOutActionProps
  extends LiveUsageResourceGridFilterOutActionProps {
  inRowAction: true;
  disabled?: boolean;
  tooltipTitle?: string;
}

export const LiveUsageResourceGridFilterOutAction: FC<
  | LiveUsageResourceGridRowFilterOutActionProps
  | LiveUsageResourceGridToolbarFilterOutActionProps
> = ({ masterGridId, inRowAction, onClose, disabled, tooltipTitle }) => {
  const dispatch = useAppDispatch();

  const clickHandler = useCallback(() => {
    dispatch(filterOutResourceGridResourcesThunk(masterGridId));
    onClose?.();
  }, [dispatch, onClose, masterGridId]);

  if (inRowAction) {
    return (
      <MenuItem dense onClick={clickHandler}>
        <ListItemIcon>
          <FilterAltOffIcon />
        </ListItemIcon>

        <ListItemText>Filter Out</ListItemText>
      </MenuItem>
    );
  }

  return (
    <Tooltip title={tooltipTitle} placement="top" arrow>
      <span>
        <IconButton sx={{ p: 0.5 }} onClick={clickHandler} disabled={disabled}>
          <FilterAltOffIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
};
